

















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import { ExpenseEligibility, ExpenseEligibilityStatus } from "@/shared/types";
import { useExpenseStore } from "@/employee/store/expense";

@Component({
  components: {
    Pill,
    Button
  }
})
export default class ExpenseEligibilitySelector extends Vue {
  expenseStore = useExpenseStore();

  @Prop()
  possibleExpense;

  @Prop()
  transactionType: number;

  get showConfirmedEligible () {
    return this.possibleExpense.eligibilityStatus === ExpenseEligibility.Eligible;
  }

  get showConfirmedIneligible () {
    return this.possibleExpense.eligibilityStatus === ExpenseEligibility.Ineligible;
  }

  onEligible () {
    this.saveEligibility(ExpenseEligibility.Eligible);
  }

  onIneligible () {
    this.saveEligibility(ExpenseEligibility.Ineligible);
  }

  onUndo () {
    this.saveEligibility(ExpenseEligibility.None);
  }

  saveEligibility (eligibilityStatus) {
    const expenseEligibilityStatus: ExpenseEligibilityStatus = {
      transactionType: this.transactionType,
      expenseStatusList: [
        {
          transactionId: this.possibleExpense.transactionId,
          eligibilityStatus
        }
      ]
    };

    this.expenseStore.setEligibility(expenseEligibilityStatus);
  }
}
